export default __webpack_public_path__ + "static/media/before_live_chat.fc5a5de8.webp";